import messageResource from "../../messageResource";

/**
 * Controller containing operations with properties of the {@link AT.SelectorTreeNode}
 */
const GenericSelectorTreePropertiesController = function() {};

GenericSelectorTreePropertiesController.prototype = {
    /**
     * @see AT.SelectorTreeNode#selectedProperty
     */
    selectedProperty: "selected",

    isSelected: function(item)
    {
        return item[this.selectedProperty];
    },

    setSelected: function (item, isSelected)
    {
        item[this.selectedProperty] = isSelected;
    },

    /**
     * @see AT.SelectorTreeNode#activeProperty
     */
    activeProperty: "active",

    isActive: function(item)
    {
        return item[this.activeProperty];
    },

    /**
     * @see AT.SelectorTreeNode#hiddenProperty
     */
    hiddenProperty: "hidden",

    isHidden: function (item)
    {
        return item[this.hiddenProperty];
    },

    hiddenInitProperty: "hiddenInit",

    setHiddenInit : function (item, isHiddenInit){
        item[this.hiddenInitProperty] = isHiddenInit;
    },

    isHiddenInit : function(item) {
        return item[this.hiddenInitProperty];
    },

    /**
     * Item name property name.
     */
    nameProperty: "name",

    getName: function(item)
    {
        return item[this.nameProperty];
    },

    /**
     * Item full name property name.
     */
    fullNameProperty: "fullName",

    getFullName: function(item)
    {
        return item[this.fullNameProperty];
    },

    /**
     * Item's email property name
     */
    emailProperty: "email",

    getEmail: function(item)
    {
        return item[this.emailProperty];
    },

    inactiveSuffixKey: "common.archived",

    getInactiveSuffixMessage: function()
    {
        return messageResource.getMessage(this.inactiveSuffixKey);
    },

    selectedInitProperty: "selectedInit",

    setSelectedInit: function( item, isSelectedInit )
    {
        item[this.selectedInitProperty] = isSelectedInit;
    },

    isSelectedInit: function( item )
    {
        return item[this.selectedInitProperty];
    }
};

export default GenericSelectorTreePropertiesController;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/GenericSelectorTreePropertiesController.js